/**
 * Account-level and platform-default SMTP APIs (Communication → Email tab).
 */
import { getAuthHeaders } from './authHeaders';

const uiConfig = require('../../uiConfig');

const serverUrl = () => uiConfig.serverInfo.serverUrl;

export async function getAccountEmailSmtp(accountId) {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/getAccountEmailSmtp', {
    method: 'POST',
    headers,
    body: JSON.stringify({ account_id: accountId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || 'Unable to load email server settings.');
  }
  return data;
}

/**
 * @param {string} accountId
 * @param {object} emailSmtp - { host, port, secure, user, pass?, from }
 */
export async function saveAccountEmailSmtp(accountId, emailSmtp) {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/saveAccountEmailSmtp', {
    method: 'POST',
    headers,
    body: JSON.stringify({ account_id: accountId, email_smtp: emailSmtp }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || 'Unable to save email server settings.');
  }
  return data;
}

export async function clearAccountEmailSmtp(accountId) {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/clearAccountEmailSmtp', {
    method: 'POST',
    headers,
    body: JSON.stringify({ account_id: accountId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || 'Unable to clear email server settings.');
  }
  return data;
}

/** Super Admin: platform default SMTP status. */
export async function getSystemEmailSmtp() {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/getSystemEmailSmtp', {
    method: 'POST',
    headers,
    body: JSON.stringify({}),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || 'Unable to load system email server settings.');
  }
  return data;
}

export async function saveSystemEmailSmtp(emailSmtp, accountId) {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/saveSystemEmailSmtp', {
    method: 'POST',
    headers,
    body: JSON.stringify({ email_smtp: emailSmtp, account_id: accountId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || 'Unable to save system email server settings.');
  }
  return data;
}

export async function clearSystemEmailSmtp(accountId) {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/clearSystemEmailSmtp', {
    method: 'POST',
    headers,
    body: JSON.stringify({ account_id: accountId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || 'Unable to clear system email server settings.');
  }
  return data;
}
